module.exports = "\r\n\r\n\r\n.panel {\r\n  border: 1px solid #d1d6e6;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-components/action-based-notifications/edit-action-notification/edit-action-notification.component.css
// module id = ./src/app/notification-components/action-based-notifications/edit-action-notification/edit-action-notification.component.css
// module chunks = main